import * as RadixSwitch from "@radix-ui/react-switch";
import React from "react";
import clsx from "clsx";

export const Switch = ({ checked = false, onCheckedChange, disabled = false }) => {
  return (
    <RadixSwitch.Root
      className={clsx(
        "relative h-6 w-11 rounded-full border border-transparent bg-slate-200 transition-colors duration-200",
        {
          "bg-primary border-primary": checked,
          "cursor-not-allowed bg-slate-200 opacity-50": disabled,
        }
      )}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
    >
      <RadixSwitch.Thumb
        className={clsx(
          "block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow transition-transform duration-200",
          {
            "translate-x-5": checked,
          }
        )}
      />
    </RadixSwitch.Root>
  );
};
